import { Component, OnInit,ViewChild,ElementRef,Optional } from '@angular/core';
import { NavController, LoadingController,ModalController,IonRouterOutlet } from '@ionic/angular';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { CatgoryPipe } from '../../../pipe/categorypipe';
//import { OrderByPipe } from '../../../pipe/orderbypipe';
import { SearchPipe } from '../../../pipe/searchpipe';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVars } from '../../../providers/globalVars';
import { ActivatedRoute } from '@angular/router';

declare var google;
@Component({
  selector: 'app-listmap',
  templateUrl: './listmap.page.html',
  styleUrls: ['./listmap.page.scss'],
})
export class ListmapPage implements OnInit {
  @ViewChild('map') mapElement: ElementRef;
  type:any
  allitems: any[] = [];
  items: any[] = [];
  category: any[] = [];
  mapAddress: any;
  map: any;
  markerSelected: boolean = false;
  alltitle:any;
  selectopt:any;
  selectalltxt:any;
  selectedcat:any[] = [];
  selectedcategory:any = '';
  mapMarkers:any[] = [];
  nearme:boolean = false;
  //mapStyle: any = "style=element:geometry.fill%7Csaturation:-60%7Cweight:2";

  mapStyle: any =
  [{"featureType":"landscape.man_made","elementType":"all","stylers":[{"color":"#faf5ed"},{"lightness":"0"},{"gamma":"1"}]},
                  {"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#bae5a6"}]},
                  {"featureType":"road","elementType":"all","stylers":[{"weight":"1.00"},{"gamma":"1.8"},{"saturation":"0"}]},
                  {"featureType":"road","elementType":"geometry.fill","stylers":[{"hue":"#ffb200"}]},
                  {"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"lightness":"0"},{"gamma":"1"}]},
                  {"featureType":"transit.station.airport","elementType":"all","stylers":[{"hue":"#b000ff"},{"saturation":"23"},{"lightness":"-4"},{"gamma":"0.80"}]},
                  {"featureType":"water","elementType":"all","stylers":[{"color":"#a0daf2"}]}];

  infoWindows: any=[];
  chlistdir:any;
  initchk:boolean = true;
  selectmarker:any;

  all:any;
  p_eat:any;
  p_travel:any;
  p_living:any;
  p_shopping:any;
  p_culture:any;
  others:any;

  loaddone:boolean = false;
  initload:boolean = true;
  modal;
  cangoback;

  blocked:any;
  currentview:any;
  constructor(public navCtrl: NavController,private route: ActivatedRoute, public modalCtrl:ModalController, 
    public loadingCtrl: LoadingController , private gv:GlobalVars,
    public translate: TranslateService, public categorypipe: CatgoryPipe, 
    public searchpipe: SearchPipe
    ,@Optional() private outlet: IonRouterOutlet, private geolocation: Geolocation) {
      this.chlistdir = gv.getListDir();  
      this.translate.get('selectcategories').subscribe(res=>{
        this.selectopt = {subTitle:res};
      });
      //this.translate.get('mapview').subscribe(res=>{
      //  this.title = res;
      //});
      this.translate.get('All').subscribe(res=>{
        this.selectalltxt = res;
      });
      this.translate.get('All').subscribe(res=>{this.alltitle = res;});
  }

  ngOnInit() {
      this.cangoback = this.outlet && this.outlet.canGoBack();
      //this.blocked = this.route.snapshot.paramMap.get('blocked');
      if(this.route.snapshot.paramMap.get('type'))
        this.type = this.route.snapshot.paramMap.get('type');
      else
        this.type = 'place';

      if(this.type == 'place')
        {
        if(this.route.snapshot.paramMap.get('typemain'))
          this.selectedcategory = this.route.snapshot.paramMap.get('typemain');
      
        this.translate.get('Eat').subscribe(res=>{
        this.p_eat = res;
        });
        this.translate.get('Trip').subscribe(res=>{
        this.p_travel = res;
        });
        this.translate.get('Living').subscribe(res=>{
        this.p_living = res;
        });
        this.translate.get('Shopping').subscribe(res=>{
        this.p_shopping = res;
        });
        this.translate.get('Culture').subscribe(res=>{
        this.p_culture = res;
        });
        this.translate.get('others').subscribe(res=>{
        this.others = res;
        });
        this.category = [{name:this.p_eat}, {name:this.p_travel}, {name:this.p_living}, {name:this.p_shopping}, {name:this.p_culture},{name:this.others}
          //, {name:life}, {name:office}, {name:travel},
        //{name:kid}, {name:camp}, {name:others}
        ];
        }
      else if(this.type=='house')
        {
          var male, female, couple, single, master, twin, others;
          this.translate.get('male').subscribe(res=>{
            male = res;
          });
          this.translate.get('female').subscribe(res=>{
            female = res;
          });
          this.translate.get('couple').subscribe(res=>{
            couple = res;
          });
          this.translate.get('singleroom').subscribe(res=>{
            single = res;
          });
          this.translate.get('masterroom').subscribe(res=>{
            master = res;
          });
          this.translate.get('twinroom').subscribe(res=>{
            twin = res;
          });
          this.translate.get('others').subscribe(res=>{
            others = res;
          });
          this.category = [{name:male},{name:female},{name:couple},{name:single},{name:master},{name:twin},{name:others}];
        }
        
      //this.afDB.database.ref(this.chlistdir).orderByChild('type')
      //.equalTo(this.type).once('value').then(listitems=>{
        
      //).catch(_=>{})
      /*
      setTimeout(_=> 
        {
        if(this.navParams.get('nearme'))
         this.getCurrentLocation()
        else
          this.displayGoogleMap()
        }, 500);*/
  }
  
  ionViewDidEnter(){
    //console.log(this.initload);
    if(this.initload)// && this.gv.param['mapdata'])
        {
        this.initload = false;
        let listitems = this.gv.param['mapdata'];
        //console.log(listitems.length)
        if(listitems)
        listitems.forEach(element => {
          var data = element;//.val();
          var img = '';
          if(data.imagethumb)
            img = data.imagethumb[0]['url'];
          let todaytime = new Date().getTime();
    
          if(this.type == 'place')
          {
            var infodata;
            if(data.openhour)
              {
              var openhours;
              this.translate.get('openhours').subscribe(res=>{
                openhours = res;
              });
              infodata = openhours + ":" + data.openhour + "<br><span class='spantag'>" + data.hashtag + "</span>";
              }
            else
              infodata = (data.hashtag?data.hashtag+'<br>':data.formdata['fieldlist']['2']?data.formdata['fieldlist']['2'].value:data.category) + "<br><span class='spantag'>" + data.description + "</span>";
            if(data.formdata && data.formdata['fieldlist'] && data.formdata['fieldlist']['4'])
            {
              data.lat = data.formdata['fieldlist']['4'].lat;
              data.lng = data.formdata['fieldlist']['4'].lng;
            }
            if(!data.typemain)
            {
              data.typemain = data.category.split(' - ')[0];
              data.typesub = data.category.split(' - ')[1]?data.category.split(' - ')[1]:'';
            }
            this.allitems.push({key:element.$key, typemain:data.typemain, typesub:data.typesub, title:data.title, 
              info:infodata, lat:data.lat, lng:data.lng, categoryName:data.categoryName, 
              createdDate:data.createdDate,
            mainimg:img});
          }
          else if(this.type == 'house')
          {
            if(data.state != 'close' && data.typemain != 'findshare' && data.createdDate && (todaytime - data.createdDate)/1000/24/60/60 < 62)
            {
            var infoStr = '';
            if(data.formdata && data.formdata.fieldlist['1']['value'])
            {
              for(var i=0; i < data.formdata.fieldlist['1']['value'].length; i++)
              {
                let room = data.formdata.fieldlist['1']['value'][i];
                var canmovein, monthwith, startfrommsg;
                this.translate.get('canmovein').subscribe(res=>{
                  canmovein = res;
                });
                this.translate.get('monthwith').subscribe(res=>{
                  monthwith = res;
                });
                this.translate.get('startfrom').subscribe(res=>{
                  startfrommsg = res;
                });
                /*
                var startfrom = new Date(data.rooms[i].startfrom);
                var startStr
                if(monthwith == ' of ')
                  startStr = canmovein + startfrom.getDate().toString() + monthwith + (startfrom.getMonth()+1).toString();
                else
                 startStr = (startfrom.getMonth()+1).toString()+ monthwith +startfrom.getDate().toString() + startfrommsg;
                  infoStr += '['+data.rooms[i].roomtype+']' + data.rooms[i].okpax + ', ' + data.rooms[i].per + '$' + data.rooms[i].price + '/' + data.rooms[i].period + '<br>'
                  + startStr;
                  */
                infoStr += '<b><span style="color:#fe774a">' + room.val0 + '</span> &nbsp;' +  room.val2 + ', ' + room.val3 + '</b><br>' + room.val1lbl + ' ' + room.val1;
                
                if(i != data.formdata.fieldlist['1']['value'].length-1)
                  infoStr += '<br>'
              }
            }
            else
              infoStr = data.description;

            var anygender, malefemale;
            this.translate.get('anygender').subscribe(res=>{
              anygender = res;
            });
            this.translate.get('malefemale').subscribe(res=>{
              malefemale = res;
            });
            if(data.formdata)
            this.allitems.push({key:element.$key, title:data.title, info:infoStr, 
              lat:data.formdata.fieldlist['3']['lat']?data.formdata.fieldlist['3']['lat']:data.lat, 
              lng:data.formdata.fieldlist['3']['lng']?data.formdata.fieldlist['3']['lng']:data.lng,
              searchStr:infoStr.replace(anygender, malefemale), createdDate:data.createdDate,
            mainimg:img});
            }
          }
        });

        if(this.route.snapshot.paramMap.get('center') && this.route.snapshot.paramMap.get('center') != '시티')  
          this.nearme = true;
        else
          this.nearme = false;
        if(this.route.snapshot.paramMap.get('typemain'))
        {
            this.allitems.forEach(item=>{
            if(item.typemain == this.route.snapshot.paramMap.get('typemain'))
              this.items.push(item);
          })
        }
        else
        {
        this.items = this.allitems;
        }
        //this.items = this.items.slice(0,30);
        if(this.nearme)
           this.getCurrentLocation()
        else
          this.displayGoogleMap('init')
        //console.log(this.nearme)   
      }
      else //맵데이터 없음
      {}
  }

  close(){
    if(`${this.modal}` != 'undefined') 
      this.modalCtrl.dismiss();
    if(this.cangoback)
      {this.navCtrl.pop();}
    else
      this.navCtrl.navigateBack('/');
  }

 
  catchange()
  {
    this.items = [];
    this.clearMarkers();
    if(this.selectedcategory)
    {
      if(this.selectmarker && this.selectmarker.typemain != this.selectedcategory)
        {
          //console.log(this.selectmarker.typemain);
          //console.log(this.selectmarker);
          this.selectmarker = null;
        }
        
      //else
      //    this.selectmarker.setMap(this.map);
      if(this.type=='place')
      {
        this.items = this.categorypipe.transform(this.allitems, 'typemain', this.selectedcategory);
        /*
        this.selectedcat.forEach(element => {
          this.categorypipe.transform(this.allitems, 'typemain', element).forEach(item=>
          this.items.push(item));
        });*/
      }
      else if(this.type=='house')
      {
        this.items = this.searchpipe.transform(this.allitems, 'searchStr', this.selectedcategory);
        /*
        this.selectedcat.forEach(element => {
          this.searchpipe.transform(this.allitems, 'searchStr', element).forEach(item=>
          this.items.push(item));
        });
        */
      }
    }
    else
    {
      this.items = this.allitems; //this.orderbypipe.transform(this.allitems, 'createdDate', 'desc');
      //this.items = this.items.slice(0,30);
    }
    this.addMarkersToMap();
  }

  displayGoogleMap(val?) {
    var zoomrate = 15;
    if(this.type != 'place')
      zoomrate = 14;
    
    let latLng;
    if(this.gv.loc == 'brisbane')
      latLng = new google.maps.LatLng(-27.46794,153.02809);
    else
      latLng = new google.maps.LatLng(-16.922992, 145.773275);
    let mapOptions = {
        center: latLng,
        zoom: zoomrate,
        styles: this.mapStyle,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: false,
        zoomControlOptions: {
              position: google.maps.ControlPosition.RIGHT_CENTER
          },
        streetViewControlOptions: {
              position: google.maps.ControlPosition.RIGHT_CENTER
          },
    };
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    if(val && this.type == 'place')
    {
      var cityCircle = new google.maps.Circle({
      strokeColor: '#5a82e1',
      strokeOpacity: 0.7,
      strokeWeight: 2,
      fillColor: '#5a82e1',
      fillOpacity: 0.20,
      map: this.map,
      center: latLng,
      radius: 500
      });
    }
    this.currentview = 'city';
    this.addMarkersToMap()
  }

getCurrentLocation(){
        var zoomrate = 14;
        //if(this.type != 'place')
        //  zoomrate = 13;
        
        var finding, currentlocation, rejectedcurrent;
        this.translate.get('finding').subscribe(res=>{
          finding = res;
        });
        this.translate.get('currentlocation').subscribe(res=>{
          currentlocation = res;
        });
        this.translate.get('rejectedcurrentlocationbyuser').subscribe(res=>{
          rejectedcurrent = res;
        });

        this.geolocation.getCurrentPosition().then((position) => {
            let latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
            let mapOptions = {
            center: latLng,
            zoom: zoomrate,
            styles: this.mapStyle,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: false,
            zoomControlOptions: {
                  position: google.maps.ControlPosition.RIGHT_CENTER
              },
            streetViewControlOptions: {
                  position: google.maps.ControlPosition.RIGHT_CENTER
              },
            };
            this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
            this.map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
            
            let marker = new google.maps.Marker({
                map: this.map,
                icon: new google.maps.MarkerImage('//maps.gstatic.com/mapfiles/mobile/mobileimgs2.png',
                new google.maps.Size(22, 22),
                new google.maps.Point(0, 18),
                new google.maps.Point(11, 11)),
                position: latLng
            });

            var cityCircle = new google.maps.Circle({
            strokeColor: '#555555',
            strokeOpacity: 0.7,
            strokeWeight: 2,
            fillColor: '#555555',
            fillOpacity: 0.20,
            map: this.map,
            center: latLng,
            radius: 500
            });

            let content = "<div>" + currentlocation + "</div>";
            //this.addInfoWindow(marker, content);
            this.currentview = 'around'; 
            this.addMarkersToMap()
            
            //loadingPopup.dismiss();  

        }, (err) => {
            alert(rejectedcurrent)
            //console.log(err);
            //loadingPopup.dismiss();  

        });  
         

  }
 
  addInfoWindow(marker, content){
      let infoWindow = new google.maps.InfoWindow({
          content: content
      });
      google.maps.event.addListener(marker, 'click', () => {
         this.closeAllInfoWindows();
          infoWindow.open(this.map, marker);
      });
  }

  clearMarkers()
  {
    this.mapMarkers.forEach(marker=>{
      marker.setMap(null);
    })
   this.mapMarkers = [];
   if(this.selectmarker)
    this.selectmarker.setMap(null);
  }
  addMarkersToMap() {
    var center;
     
    for(let items of this.items) {
     // var roominfo = '';
       var iconname = 'pin.png';
      var txtcolor = '#fe774a';
      if(this.type == 'place')
      {
        if(this.gv.loc == 'brisbane')
          center = new google.maps.LatLng(-27.46794,153.02809);
        else
          center =  new google.maps.LatLng(-16.922992, 145.773275); 
        switch(items.typemain){
          case this.p_eat: iconname = 'map_eat.png'; txtcolor = '#ff9069'; break;
          case this.p_travel: iconname = 'map_travel.png'; txtcolor = '#62b1ff'; break;
          case this.p_living: iconname = 'map_living.png'; txtcolor = '#ffd271'; break;
          case this.p_shopping: iconname = 'map_shopping.png'; txtcolor = '#b36bd6'; break;
          case this.p_culture: iconname = 'map_culture.png'; txtcolor = '#5a82e0'; break;
          case this.others: iconname = 'map_other.png'; txtcolor = '#d1c0a5'; break;
          //default:;
        }
      }
      else //(this.type == 'house')
        {
        if(this.gv.loc == 'brisbane')
          center = new google.maps.LatLng(-27.46794,153.02809);
        else
        center =  new google.maps.LatLng(-16.922992, 145.763275); 
        var iconname = 'map_house.png';
        }
      
      var position = new google.maps.LatLng(items.lat, items.lng);
      var mapMarker = new google.maps.Marker({
            position: position,
            animation: google.maps.Animation.DROP,
            markerSelected : true,
            key:items.key,
            title: items.title,
            info: items.info, 
            mainimg: items.mainimg,
            label: {
              text:items.title.length > 8? items.title.substr(0,7) + '..' : items.title, 
              fontSize:'11px',
              fontWeight:'bold',
              color:txtcolor
            },
            //icon:'assets/red_pin72x96.png'
            //**** Custom Marker Symbols ****/
            //icon:  'assets/red_pin72x96.png'
            icon: {
                    url: 'assets/icon/' + iconname,
                    //The size image file.
                    //size: new google.maps.Size(72, 96),
                    size: new google.maps.Size(28, 36),//new google.maps.Size(36, 48),
                    // we want to render @ 30x30 logical px (@2x dppx or 'Retina')
                    scaledSize: new google.maps.Size(20, 26), 
                    //The point on the image to measure the anchor from. 0, 0 is the top left.
                    origin: new google.maps.Point(0, 0),
                    //The x y coordinates of the anchor point on the marker. e.g. If your map marker was a drawing pin then the anchor would be the tip of the pin.
                    anchor: new google.maps.Point(10, 20),
                    labelOrigin: new google.maps.Point(10, -8)
                },
                anchorPoint: new google.maps.Point(0, -20)
      });
      this.mapMarkers.push(mapMarker);
      mapMarker.setMap(this.map);
      this.addInfoWindowToMarker(mapMarker);
    }
    //if(!this.nearme)
    //this.map.setCenter(center);
  }

  addInfoWindowToMarker(marker) {
    /*
      var showdetailmsg;
      this.translate.get('Show detail').subscribe(res=>{
          showdetailmsg = res;
        });
      var infoWindowContent = '<div id="iw-container">' +               
                                  '<div class="iw-content">' +
                                        '<div style="display:table-cell"><img class="markerimg" src="' + marker.mainimg + '"></div>' + 
                                        '<div style="display:table-cell;"><div class="iw-subTitle"><b>'+marker.title+'</b></div>' +                                  
                                        '<div class="iw-desc">'+marker.info+'</div></div><div class="markerbtn" id="btnshowdetail">'+ showdetailmsg + '</div>'+
                                  '</div>' +
                              '</div>';    

      var infoWindow = new google.maps.InfoWindow();
          // infoWindow.setOptions({
          //     disableAutoPan:false
          // }); 
          infoWindow.setContent(infoWindowContent);
*/
          marker.addListener('click', () => {
            
            var position = marker.position; //new google.maps.LatLng(marker.lat, marker.lng);
            if(this.selectmarker)
              this.selectmarker.setMap(null);
              this.selectmarker = new google.maps.Marker({
                  position: position,
                  //animation: google.maps.Animation.DROP,
                  markerSelected : true,
                  zIndex:google.maps.Marker.MAX_ZINDEX,
                  typemain: marker.typemain,
                  typesub: marker.typesub,
                  info: marker.info,
                  title: marker.title,
                  mainimg: marker.mainimg,
                  key: marker.key,
                  icon: {
                          url: 'assets/icon/mkborder.png',
                          //The size image file.
                          //size: new google.maps.Size(72, 96),
                          size: new google.maps.Size(40, 50),
                          // we want to render @ 30x30 logical px (@2x dppx or 'Retina')
                          scaledSize: new google.maps.Size(26, 34), 
                          //The point on the image to measure the anchor from. 0, 0 is the top left.
                          origin: new google.maps.Point(0, 0),
                          //The x y coordinates of the anchor point on the marker. 
                          //e.g. If your map marker was a drawing pin then the anchor would be the tip of the pin.
                          anchor: new google.maps.Point(13, 23)
                          //,
                          //labelOrigin: new google.maps.Point(10, -7)
                      },
                      anchorPoint: new google.maps.Point(0, -20)
            });
            marker.setZIndex(google.maps.Marker.MAX_ZINDEX);// = 1;//google.maps.Marker.MAX_ZINDEX-1;
            this.selectmarker.setMap(this.map);
            /*}
            else{
              this.selectmarker.position = position;
              this.selectmarker.typemain = marker.typemain;
              this.selectmarker.typesub = marker.typesub;
              this.selectmarker.info = marker.info;
              this.selectmarker.title = marker.title;
              this.selectmarker.mainimg = marker.mainimg;
              this.selectmarker.key = marker.key;
              marker.setMap(this.map);
              this.selectmarker.setMap(this.map);
            }*/
           this.loaddone = false;
            /*
                this.closeAllInfoWindows();
                infoWindow.open(this.map, marker);
                // add listener that will capture the click event of the infoWindow
                 google.maps.event.addListener(infoWindow, 'domready', () => {
                   
                   document.getElementById('btnshowdetail').addEventListener('click', () => {
                      this.showdetail(marker.key);
                   });
                 }); 
            */
          });
          //this.infoWindows.push(infoWindow);
  }

  closeAllInfoWindows() {
      for(let window of this.infoWindows) { 
        window.close();
      }
  }
 
/*
  dismiss() {
   this.viewCtrl.dismiss();
  }*/

}